export class BudgetDiscipline {
    id: number;
    name: string;

    constructor(data) {
        this.id = (data.budget_discipline_id || data.budgetdiscipline_pk) ? parseInt(data.budget_discipline_id ? data.budget_discipline_id : data.budgetdiscipline_pk) : null
        this.name = (data.name || data.budget_discipline) ? data.name ? data.name : data.budget_discipline : null
    }
}